<app-hero [title]="'consensi.verificationTitle' | translate" />
<div class="pt-5 text-center">
	<span class="text-blue text-xl">
		{{ "consensi." + (wrongPrameters ? "wrongParameters" : outcome === undefined ? "sendingVerification" : outcome ? "confirmed" : "verificationError") | translate }}
	</span>
	@if (outcome !== undefined) {
		<div class="text-center">
			<a
				class="btn btn-blue mt-4"
				routerLink="/"
				>{{ "consensi.backToHomepage" | translate }}</a
			>
		</div>
	}
</div>
